import React, { useState } from "react";
import { Link } from "react-router-dom";
import coat from "../../includes/images/coat.png";
import imm from "../../includes/images/immigration.png";
import "../../includes/css/template.css";
import "../../includes/assets/5aa1fa4e/css/font-awesome.min.css";
import "../../includes/assets/40b83da1/css/bootstrap.css";

function Header() {
  const [showModal, setShowModal] = useState(false);
  const handleModalToggle = () => {
    setShowModal(!showModal);
  };

  return (
    <>
      <div className="logoBar">
        <div className="container">
          <div className="row">
            <div className="col-md-1 col-sm-1 col-xs-1 vertical-align text-left hidden-xs">
              <img src={coat} alt="Coat of Arms Logo" />
            </div>

            <div className="col-md-10 col-sm-10 col-xs-12 vertical-align text-center">
              <div className="visible-xs">
                <img src={coat} alt="Coat of Arms Logo" />
              </div>

              <h5 className="m-b-1">Travel Document Page</h5>
              <nav
                className="navbar navbar-main navbar-default"
                role="navigation"
                style={{ opacity: 1 }}
              >
                <div className="container col-sm-12">
                  <div className="navbar-header">
                    <button
                      type="button"
                      className="navbar-toggle"
                      data-toggle="collapse"
                      data-target=".navbar-1"
                    >
                      <span className="sr-only">Toggle navigation</span>
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                    </button>
                  </div>

                  <div
                    className="collapse navbar-collapse navbar-1"
                    style={{ marginTop: "0px" }}
                  >
                    <ul className="nav navbar-nav">
                      <li>
                        <Link onClick={handleModalToggle}>
                          Verification of Emergency Document Information
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
            </div>

            <div className="col-md-1 col-sm-1 col-xs-1 vertical-align hidden-xs">
              <img src={imm} alt="Immigration Logo" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
